
  import { Vue, Component, Prop } from "vue-property-decorator";

  import EditPaymentCardForm from "@/components/payment/EditPaymentCardForm.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ModalWithTrigger from "@/components/modal/ModalWithTrigger.vue";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";

  @Component({
    components: {
      EditPaymentCardForm,
      UiButton,
      ModalWithTrigger,
      ModalSectionsDivider,
    },
  })
  export default class EditPaymentCardModal extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly cardId!: string;

    onCardEdited(closeModal: Function): void {
      this.$emit("cardEdited");
      closeModal();
    }
  }
